import { Role } from '@caresend/types';
import { formatFullName, asyncTimeout } from '@caresend/utils';
import { defineComponent, computed, ref } from 'vue';
import __vue_component__$1 from '../../../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$3 from '../../../../../../../../layout/NavBar/components/UserBanner.vue.js';
import __vue_component__$2 from '../../../../../../../../ui/SuperPopover/SuperPopover.vue.js';
import __vue_component__$5 from '../../../../../../../../ui/Tag/Tag.vue.js';
import __vue_component__$4 from '../../../../../../../../ui/UserPhoto/UserPhoto.vue.js';

var script = defineComponent({
    name: 'TableUserNode',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        SuperPopover: __vue_component__$2,
        UserBanner: __vue_component__$3,
        UserPhoto: __vue_component__$4,
        Tag: __vue_component__$5,
    },
    props: {
        bannerStyle: {
            type: String,
            default: 'compact',
        },
        disablePopup: {
            type: Boolean,
            default: false,
        },
        userPhotoSize: {
            type: Number,
            default: 24,
        },
        users: {
            type: Array,
            default: null,
        },
        actions: {
            type: Array,
            default: () => [],
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const firstUser = computed(() => { var _a, _b; return (_b = (_a = props.users) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null; });
        const hasRemainingUsers = computed(() => { var _a, _b; return ((_b = (_a = props.users) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1; });
        const formattedName = computed(() => {
            var _a;
            if (!firstUser.value)
                return '';
            const withTitle = ((_a = firstUser.value) === null || _a === void 0 ? void 0 : _a.role) !== Role.PATIENT;
            const withMiddle = !withTitle;
            return formatFullName(firstUser.value, withMiddle, withTitle);
        });
        const isOpened = ref(false);
        const setIsOpened = (newVal) => {
            isOpened.value = newVal;
        };
        const disabled = computed(() => {
            var _a, _b;
            return props.disablePopup
                || ((_b = (_a = props.users) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0;
        });
        const performAction = async (action, user, shouldClose = true) => {
            if (shouldClose) {
                isOpened.value = false;
                // Wait for the popover to close before performing the action
                await asyncTimeout(100);
            }
            if (action.action) {
                action.action(user);
            }
        };
        const triggerComponent = computed(() => {
            if (props.bannerStyle === 'card')
                return 'BasicCard';
            return 'div';
        });
        return {
            formattedName,
            hasRemainingUsers,
            firstUser,
            isOpened,
            setIsOpened,
            disabled,
            performAction,
            triggerComponent,
        };
    },
});

export { script as default };
